

import "../css/style.scss"
// For translation use the __(string, domain) function
//const __ = wp.i18n.__
import $ from "jquery";
import Slider from "./modules/Slider.js";



//Modules 
import "./modules/NumberInput.js";
import "./modules/Glowingcards.js";
import "./modules/Popup.js";
import "./modules/Switch.js";
import "./modules/Form.js";
import "./modules/NotificationBanner.js";
import "./modules/FadeInLater.js";
import "./modules/Faq.js";
import "./modules/Nav-menu-mobile.js";
import "./modules/ZondagGesloten.js";
import "./modules/BackdropOverlay.js";
import "./modules/Switcher.js";
import "./modules/HelperFunctions.js";
import Search from "./modules/Search.js";
import TimeNotifications from "./modules/Openingtimes.js";


// Blocks 
import "./blocks/Zooming-video.js";
import "./blocks/Video.js";
import "./blocks/Werkwijze.js";
import "./blocks/Glasprofielen.js";
import "./blocks/BeforeAfterSlider.js";
import "./blocks/HomepageHero.js";
import "./blocks/Producten.js";

// Pages 
import "./pages/Inspiratiemagazine.js";
import "./pages/Projecten.js";
import "./pages/Blog.js";


// Woocommerce
import "./woocommerce/content-product.js";
import "./woocommerce/single-product/config.js";
import "./woocommerce/single-product/general.js";
import "./woocommerce/cart/cart.js";
import "./woocommerce/cart/cart-upload-image.js";
import "./woocommerce/checkout/checkout.js";


// Document ready
$(function(){
    let viewportWidth = $(window).width();

    document.querySelectorAll('.swiper-slide img[title]').forEach(img => img.removeAttribute('title'));
    // Homepage
    if ($('body.home').length){

    }
    
    const timeNotifications = new TimeNotifications();
    timeNotifications.setPickupNotificationText('.footer__bereikbaar');
    timeNotifications.setPickupNotificationText('.timenotification-email');
    timeNotifications.setPickupNotificationText('.timenotification-phone');
    timeNotifications.setPickupNotificationText('.usp-banner__bereikbaar');
    timeNotifications.setPickupNotificationText('.nav-menu-popup__bereikbaar');
    const search = new Search();

    if (viewportWidth < 1024){

    }


    // Prevent form submission on Enter key (desktop + mobile)
    $('form').on('keydown', 'input', function(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            return false;
        }
    });

    // Optionally, prevent form's default submit just in case
    $('form').on('submit', function(e) {
        // Add a condition here if you only want to block in certain cases
        e.preventDefault();
    });

    

});








